/**
 * The label field - used for Google Analytics
 */
function backupType(type, isNotarized) {
  if (isNotarized) {
    return {
      i18nKey: 'wrh-dashboard.side-bar.backup-type.notarized',
      label: 'notarize'
    };
  }

  if (type === 'BACKUP' || type === 'A3_BACKUP' || type === 'ARPF_BACKUP') {
    return {
      i18nKey: 'wrh-dashboard.side-bar.backup-type.file',
      label: 'file'
    };
  }

  if (type === 'DISK_BACKUP' || type === 'A3_DISK_BACKUP') {
    return {
      i18nKey: 'wrh-dashboard.side-bar.backup-type.disk',
      label: 'image'
    };
  }

  if (type === 'SYNC') {
    return {
      i18nKey: 'wrh-dashboard.side-bar.backup-type.sync',
      label: 'sync'
    };
  }

  if (type === 'ENTIRE_PC' || type === 'A3_ENTIRE_PC_BACKUP') {
    return {
      i18nKey: 'wrh-dashboard.side-bar.backup-type.entire-pc',
      label: 'entire_pc'
    };
  }

  if (type === 'ARCHIVING') {
    return {
      i18nKey: 'wrh-dashboard.side-bar.backup-type.archiving',
      label: 'archive'
    };
  }

  console.log('Undefined backup type', type);
  return {
    i18nKey: 'undefined',
    label: 'undefined'
  };
}

export default backupType;
